const BannerLineSkeleton = () => {
  return <div className="w-full h-[calc(68_*_100vw_/_375)] skeletton bg-surface-200-bg" />;
};

export default BannerLineSkeleton;
